import { PUBLIC_PROFILE_URL } from 'globalConstants'

const copyTextToClipboard = (username: string) => {
  navigator.clipboard.writeText(`https://${PUBLIC_PROFILE_URL}/${username}`)
  return true
}

export default copyTextToClipboard
